package it.neckar.lizergy.model.price

import it.neckar.lizergy.lifeCycle.LizergyHasLifeCycle
import it.neckar.lizergy.model.financial.currency.PriceWithProfit
import it.neckar.lizergy.model.financial.currency.PriceWithProfitAndWorkingTime
import it.neckar.uuid.HasUuid
import kotlin.uuid.Uuid

/**
 * Returns the price for the given element
 */
fun <T> InfoForType<T, PriceWithProfit>.price(element: T): PriceWithProfit where T : HasUuid, T : LizergyHasLifeCycle {
  return price(element.uuid)
}

/**
 * Returns the price for the element with the given uuid
 */
fun <T> InfoForType<T, PriceWithProfit>.price(uuid: Uuid): PriceWithProfit where T : HasUuid, T : LizergyHasLifeCycle {
  return values[uuid] ?: throw IllegalArgumentException("No price found for <$uuid>")
}

fun <T> InfoForType<T, PriceWithProfitAndWorkingTime>.price(uuid: Uuid): PriceWithProfitAndWorkingTime where T : HasUuid, T : LizergyHasLifeCycle {
  return values[uuid] ?: throw IllegalArgumentException("No price found for <$uuid>")
}

fun <T> InfoForType<T, PriceWithProfit>.priceOrNull(element: T): PriceWithProfit? where T : HasUuid, T : LizergyHasLifeCycle {
  return priceOrNull(element.uuid)
}

fun <T> InfoForType<T, PriceWithProfit>.priceOrNull(uuid: Uuid): PriceWithProfit? where T : HasUuid, T : LizergyHasLifeCycle {
  return values[uuid]
}
